import React from 'react'

/**
 * ============================================
 *  Function Validation Steps
 * ============================================
 * | Step | What It Checks                         | Action Taken if Check Fails                  |
 * |------|--------------------------------------|---------------------------------------------|
 * | 1. Open IndexedDB | Tries to open `"HLTHTEK-DB"`. | Logs `"IndexedDB error."` and calls `callback(null)`. |
 * | 2. Check Object Store | Checks if `"T_ORG"` exists in the database. | Logs `"T_ORG store does not exist."` and calls `callback(null)`. |
 * | 3. Retrieve ORG_CODE | Fetches `"ORG_CODE"` from `"T_ORG"`. | Logs `"Error fetching ORG_CODE."` and calls `callback(null)`. |
 * | 4. Retrieve APP_MODE | Fetches `"APP_MODE"` from `"T_ORG"`. | Logs `"Error fetching APP_MODE."` and calls `callback(null)`. |
 * | 5. Validate Data | Checks if both `"ORG_CODE"` and `"APP_MODE"` exist and are non-empty. | Logs `"ORG_CODE or APP_MODE is missing."` and calls `callback(null)`. |
 * | 6. Return Data | Returns `{ app_mode, org_code }` via `callback`. | - |
 */

export const fetchOrgCodeAndValidate = (callback) => {
    const request = indexedDB.open("HLTHTEK-DB");
  
    request.onsuccess = (event) => {
      const db = event.target.result;
  
      if (!db.objectStoreNames.contains("T_ORG")) {
        console.error("T_ORG store does not exist.");
        db.close(); // Close DB on error
        callback(null);
        return;
      }
  
      const transaction = db.transaction("T_ORG", "readonly");
      const store = transaction.objectStore("T_ORG");
  
      const orgCodeRequest = store.get("ORG_CODE");
      const appModeRequest = store.get("APP_MODE");
  
      orgCodeRequest.onsuccess = () => {
        appModeRequest.onsuccess = () => {
          const orgCode = orgCodeRequest.result || "";
          const appMode = appModeRequest.result || "";
          db.close(); // Close DB on error
  
          if (orgCode.trim() !== "" && appMode.trim() !== "") {
            callback({ app_mode: appMode, org_code: orgCode });
          } else {
            console.error("ORG_CODE or APP_MODE is missing.");
            callback(null);
          }
        };
  
        appModeRequest.onerror = () => {
          console.error("Error fetching APP_MODE.");
          db.close(); // Close DB on error
          callback(null);
        };
      };
  
      orgCodeRequest.onerror = () => {
        console.error("Error fetching ORG_CODE.");
        db.close(); // Close DB on error
        callback(null);
      };
    };
  
    request.onerror = () => {
      console.error("IndexedDB error.");
      callback(null);
    };
  };
  